module.exports = __webpack_public_path__ + "static/media/drone2.f355ca68.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/alset-reactgame-test/commonGameAssets/characters/drone2.png
// module id = 439
// module chunks = 0